import { render, staticRenderFns } from "./RulebookFeedbackTab.vue?vue&type=template&id=3c08fbfa&scoped=true&"
import script from "./RulebookFeedbackTab.vue?vue&type=script&lang=js&"
export * from "./RulebookFeedbackTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookFeedbackTab.vue?vue&type=style&index=0&id=3c08fbfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08fbfa",
  null
  
)

export default component.exports